import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        // Foundation tokens (docs/UI_FOUNDATION.md): navy selected day, brand-ink "today", ink/line text.
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-3",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-[13px] font-bold text-ink",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "ghost" }),
          "h-7 w-7 rounded-lg bg-transparent p-0 text-ink-3 hover:bg-surface-hover hover:text-ink"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "w-9 text-[11px] font-semibold text-ink-3",
        row: "flex w-full mt-1",
        cell: cn(
          "relative p-0 text-center text-[13px] focus-within:relative focus-within:z-20",
          props.mode === "range"
            ? "[&:has([aria-selected])]:bg-brand-soft [&:has(>.day-range-end)]:rounded-r-lg [&:has(>.day-range-start)]:rounded-l-lg first:[&:has([aria-selected])]:rounded-l-lg last:[&:has([aria-selected])]:rounded-r-lg"
            : ""
        ),
        day: "inline-flex h-8 w-9 items-center justify-center rounded-lg p-0 text-[13px] font-medium text-ink transition-colors hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring aria-selected:opacity-100",
        day_range_start: "day-range-start",
        day_range_end: "day-range-end",
        // !important: a page's modifier colour (e.g. "has requests" amber) must not hide the selection.
        day_selected: "!bg-brand font-bold !text-brand-fg !no-underline hover:!bg-brand-hover focus:!bg-brand",
        day_today: "font-bold text-brand-ink underline decoration-2 underline-offset-4",
        day_outside: "day-outside text-ink-4 aria-selected:!bg-brand-soft aria-selected:!text-ink-3",
        day_disabled: "text-ink-4 opacity-50",
        day_range_middle: "aria-selected:!bg-brand-soft aria-selected:!text-brand-ink",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn("h-4 w-4", className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn("h-4 w-4", className)} {...props} />
        ),
      }}
      {...props} />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
